module.exports = require("safe-buffer");